import * as effector from 'effector';

export * from 'effector';
export * from 'effector-react';
/**
 * @deprecated
 * @see 'effector'
 * @description Нет необходимости в этой обёртке, используйте effector напрямую
 */
export const app = effector.createDomain('@liliani-mix-and-storage');
export const { createDomain, createStore, createEffect, createEvent } = app;
